<template>
<div class="text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden mt-1">
    <div class="pt-3 bg-[#2B2C32] px-[16px] py-[16px] rounded-xl">
        <p class="text-xs font-normal tracking-wider text-theme-878686 text-center pb-2">Drag &amp; Drop your files below or upload it manually by pressing the “+” symbol</p>
            <div>
                <div>
                    <div class="flex flex-row border border-theme-green rounded-xl" @dragenter.prevent="dragging=true" @dragover.prevent="dragging=true"  @dragleave.prevent="dragging=false" @drop.prevent="addFile" draggable="false">
                        <div class="flex bg-theme-green/30 w-[55px] border-r border-theme-green rounded-tl-xl rounded-bl-xl">
                            <block-loading v-if="uploading" class="self-center" style="height:150px !important; width:55px !important;" />
                            <label v-else for="uploadFile" class="px-2 self-center cursor-pointer">
                                <div class="self-center input-wrapper">
                                    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M16.9987 37.6673V21.0007H0.332031V17.0007H16.9987V0.333984H20.9987V17.0007H37.6654V21.0007H20.9987V37.6673H16.9987Z" fill="#2BA66B"/>
                                    </svg>
                                </div>
                            </label>
                        </div>
                        <input ref="uploadFile" id="uploadFile" class="hidden" multiple type="file" @change="addFile" />
                        <div v-if="images.length>0" id="sortableMedia" class="flex flex-row flex-wrap min-h-[150px]">
                            <div class="input-wrapper" v-for="image in images" :key="image.id" :id="image.id">
                                <div class="m-1 relative">
                                    <img :src="image.url" class="w-[148px] h-[150px]" />
                                    <div class="absolute top-2 left-2 cursor-pointer">
                                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.25 14.25V12.75H20.25V14.25H4.25ZM4.25 11.25V9.75H20.25V11.25H4.25Z" fill="white" stroke="green"/>
                                        </svg>
                                    </div>
                                    <div class="absolute top-2 right-2 cursor-pointer" @click="deleteImage(image)">
                                        <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1.47578 13.8248L0.425781 12.7748L6.20078 6.9998L0.425781 1.2248L1.47578 0.174805L7.25078 5.9498L13.0258 0.174805L14.0758 1.2248L8.30078 6.9998L14.0758 12.7748L13.0258 13.8248L7.25078 8.0498L1.47578 13.8248Z" fill="#F53333"/>
                                        </svg>
                                    </div>
                                    <div class="absolute bottom-2 right-2 cursor-pointer">
                                        <svg @click="updateImage(image, false)" v-if="image.default" width="20" height="20" viewBox="0 0 31 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15.25 3.23607L17.8912 11.3647L18.1157 12.0557H18.8422H27.3892L20.4746 17.0795L19.8868 17.5066L20.1113 18.1976L22.7524 26.3262L15.8378 21.3024L15.25 20.8754L14.6622 21.3024L7.74755 26.3262L10.3887 18.1976L10.6132 17.5066L10.0254 17.0795L3.11078 12.0557H11.6578H12.3843L12.6088 11.3647L15.25 3.23607Z" fill="#2BA66B" stroke="#2BA66B" stroke-width="2"/>
                                        </svg>
                                        <svg @click="updateImage(image, true)" v-else width="20" height="20" viewBox="0 0 31 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15.25 3.23607L17.8912 11.3647L18.1157 12.0557H18.8422H27.3892L20.4746 17.0795L19.8868 17.5066L20.1113 18.1976L22.7524 26.3262L15.8378 21.3024L15.25 20.8754L14.6622 21.3024L7.74755 26.3262L10.3887 18.1976L10.6132 17.5066L10.0254 17.0795L3.11078 12.0557H11.6578H12.3843L12.6088 11.3647L15.25 3.23607Z" stroke="#2BA66B" stroke-width="2"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else-if="!uploading" class="flex flex-row flex-wrap items-center pl-2 min-h-[120px]">
                            No media found.
                        </div>
                    </div>
                </div>
            </div>
    </div>
</div>
</template>
<script>
import { defineComponent, ref } from 'vue'
import ResourceApi from '@/controllers/BusinessProductResourceApis'
import ProductApis from '@/controllers/BusinessProductApis'
import { useSnackbar } from "vue3-snackbar";
import {mapMutations} from 'vuex'
import Sortable from 'sortablejs';
import Helpers from '@/helpers';

export default defineComponent({
    props: ['editItem'],
    setup() {
        const snackbar = useSnackbar();
        const uploading = ref(false)
        const images = ref([])
        const validImages = ref(["image/jpeg", "image/png", "image/jpg"])

        return {snackbar, uploading, images, validImages}
    },
    async mounted(){
        this.uploading = true
        await this.getProductImage()
        this.draggable()
        this.uploading = false
    },
    methods: {
        async getProductImage(){
            let result = await ProductApis.getProductImage(this.editItem.id)
            if(result?.data?.payload?.productImages){
                this.images = result.data.payload.productImages
            }
        },
        draggable(){
            this.el = document.getElementById('sortableMedia');
            if(this.el){
                Sortable.create(this.el, {
                    animation: 100,
                    onSort: this.collectData
                });
            }
        },
        async collectData(e){
            this.uploading = true
            let sortedObj = []
            for(let item of this.el.children){
                sortedObj.push(parseInt(item.id))
            }
            let imageIds = {
                productId: this.editItem.id,
                imageIds: sortedObj
            }
            let res = await ProductApis.sortProductImage(imageIds)
            this.snackbar.add({
                type: 'info',
                text: (res.data.message)?res.data.message:Helpers.catchErrorMessage(res.response.data),
                duration: 3000,
            })
            this.uploading = false

        },
        async addFile(e){
            let fileList = e.target.files || e.dataTransfer.files
            if(fileList?.length>0){
                let self = this
                this.uploading = true
                let cnt = 0
                const total = fileList.length
                const onFileComplete = () => {
                    cnt++
                    if(cnt === total){
                        self.uploading = false
                        self.getProductImage()
                        self.draggable()
                    }
                }
                for(let i=0; i<fileList.length; i++){
                    if(this.validImages.includes(fileList[i].type)){
                        this.readFile(fileList[i], async fileData =>{
                            try {
                                let presignedData = {
                                    business_uuid: '123',
                                    integrator_name: 'pos',
                                    content_type: fileList[i].type,
                                    name: fileList[i].name,
                                    description: ''
                                }
                                // get presigned url
                                let presignedUrlData = await ResourceApi.getPresignedUrl(presignedData)
                                if(presignedUrlData?.status == 201 && presignedUrlData?.data?.payload?.upload_url){
                                    // upload image
                                    let imageConfig = {
                                        headers: {
                                            'Content-Type': fileList[i].type
                                        }
                                    }
                                    await ResourceApi.uploadResource(presignedUrlData.data.payload.upload_url, fileList[i], imageConfig)
                                    // add image to product
                                    let productImageData = {
                                        productId: self.editItem.id,
                                        url: presignedUrlData.data.payload.full_url,
                                        default: false,
                                        sort: 1,
                                    }
                                    let uploadedImage = await ProductApis.createProductImage(productImageData)
                                    if(uploadedImage?.data?.payload){
                                        self.images.push(uploadedImage.data.payload)
                                    }
                                }else{
                                    let msg = presignedUrlData?.response?.data?.payload?.message ? presignedUrlData?.response?.data?.payload?.message : Helpers.catchErrorMessage(presignedUrlData.response.data);
                                    self.snackbar.add({
                                        type: 'info',
                                        text: msg,
                                        duration: 3000,
                                    })
                                }
                            } finally {
                                onFileComplete()
                            }
                        })
                    }else{
                        self.snackbar.add({
                            type: 'info',
                            text: 'File type not accepted. Please convert to PNG or JPEG',
                            duration: 3000,
                        })
                        onFileComplete()
                    }
                }
            }
        },
        readFile(file, callback){
            let reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = e => {
                let result = reader.result
                callback(result)
            }
        },
        async updateImage(image, featured=false, sort=1){
            this.uploading = true
            let productImageData = {
                productId: this.editItem.id,
                url: image.url,
                default: featured,
                sort: sort,
            }
            await ProductApis.updateProductImage(image.id, productImageData)
            this.uploading = false
            this.getProductImage()
        },
        deleteImage(image){
            this.confirm("Are you sure to delete this image?").then(async () => {
                let self = this
                self.vm_spinner(true)
                let res = await ProductApis.removeProductImage(image.id)
                self.snackbar.add({
                    type: 'info',
                    text: (res?.data?.message)?res.data.message:Helpers.catchErrorMessage(res.response.data),
                    duration: 3000,
                })
                self.vm_spinner(false)
                this.getProductImage()
            })
        },
        ...mapMutations({
            vm_spinner: 'spinner/mutateSpinner'
        })
    }
})
</script>
